"use client";

import {
  EventNames,
  SectionTypes,
  sendEvent,
  withSectionType,
} from "@/lib/utils/analytics";

export function BlogPostLink({
  href,
  className,
  children,
  id,
  "data-testid": dataTestId,
}: {
  href: string;
  className?: string;
  children: React.ReactNode;
  id?: string;
  "data-testid"?: string;
}) {
  return (
    <a
      href={href}
      id={id}
      data-testid={dataTestId}
      className={className}
      onClick={() =>
        sendEvent(
          EventNames.READ_BLOGS,
          withSectionType(SectionTypes.BLOG_SECTION, { blog_url: href }),
        )
      }
    >
      {children}
    </a>
  );
}
